module.exports = __webpack_public_path__ + "img/20201104_165553.b34cf3a3.jpg";